import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import icClose from '@iconify/icons-ic/twotone-close';
import icWarning from '@iconify/icons-ic/twotone-warning';
import icBusiness from '@iconify/icons-ic/twotone-business';
import icDomain from '@iconify/icons-ic/twotone-domain';
import icAssignment from '@iconify/icons-ic/twotone-assignment';
import { PhoneNumberModel } from '../../../../../../core/models/phone-number.model';
import { SupplierService } from '../../supplier.service';

export interface ContactDeleteImpactEstablishment {
  _id: string;
  label: string;
  buildings: { _id: string; label: string }[];
}

export interface ContactDeleteImpactDependency {
  name: string;
  dependencies: string[];
}

export interface ContactDeleteImpactData {
  contact: {
    _id: string;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumbers: PhoneNumberModel[];
  };
  establishments: ContactDeleteImpactEstablishment[];
  dependencies: ContactDeleteImpactDependency[];
  hasDependencies: boolean;
  totalEstablishmentsImpacted: number;
  totalBuildingsImpacted: number;
}

export interface ContactDeleteModalInput {
  supplierId: string;
  contactId: string;
}

@Component({
  selector: 'vex-supplier-contact-delete-confirmation-modal',
  templateUrl: './supplier-contact-delete-confirmation-modal.component.html',
  styleUrls: ['./supplier-contact-delete-confirmation-modal.component.scss'],
})
export class SupplierContactDeleteConfirmationModalComponent implements OnInit {
  icClose = icClose;
  icWarning = icWarning;
  icBusiness = icBusiness;
  icDomain = icDomain;
  icAssignment = icAssignment;

  loading = true;
  error = false;
  impactData: ContactDeleteImpactData;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ContactDeleteModalInput,
    public dialogRef: MatDialogRef<SupplierContactDeleteConfirmationModalComponent>,
    private supplierService: SupplierService,
  ) {}

  ngOnInit() {
    this.loadImpactData();
  }

  loadImpactData() {
    this.loading = true;
    this.error = false;
    this.supplierService.checkDeleteContactImpact(this.data.supplierId, this.data.contactId).subscribe(
      (res: any) => {
        this.impactData = res.data;
        this.loading = false;
      },
      () => {
        this.error = true;
        this.loading = false;
      },
    );
  }

  onCancel() {
    this.dialogRef.close(false);
  }

  onConfirm() {
    this.dialogRef.close(true);
  }

  onUnitaryDelete() {
    this.dialogRef.close('unitary');
  }

  formatPhoneNumbers(phoneNumbers: PhoneNumberModel[]): string {
    if (!phoneNumbers || phoneNumbers.length === 0) {
      return 'Aucun';
    }
    return phoneNumbers
      .map(p => {
        const prefix = p.prefix?.dialCode ? `(+${p.prefix.dialCode}) ` : '';
        return `${prefix}${p.phoneNumber}`;
      })
      .join(', ');
  }

  getContactFullName(): string {
    return `${this.impactData.contact.firstName} ${this.impactData.contact.lastName}`;
  }

  getDependenciesWithData(): ContactDeleteImpactDependency[] {
    return this.impactData.dependencies.filter(d => d.dependencies.length > 0);
  }
}
